import $ from 'jquery'
// import 'styles/screen.scss'
import moduleRegistry from './modules/'
import Gartner from './components/gartner'
import HomeHero from './pages/home-hero'
import Banner from './components/banner'
import Marketo from './components/marketo'

moduleRegistry.init()

$('a[href*="#"]').not('[href="#"]').on('click', (e) => {
    if (location.pathname.replace(/^\//, '') == e.currentTarget.pathname.replace(/^\//, '') && location.hostname == e.currentTarget.hostname) {
        let target = $(e.currentTarget.hash)
        target = target.length ? target : $(`[name=${e.currentTarget.hash.slice(1)}]`)
        if (target.length) {
            e.preventDefault()
            $('html, body').animate({
                scrollTop: target.offset().top
            }, 1000)
        }
    }
});

//Expose for async Marketo forms
window.$ = $
Gartner.init();
HomeHero.init();
Banner.init();
Marketo.init();
